import logo from './logo.svg';
import React, { useEffect, useState, useRef, useContext } from 'react'
import './App.css';
import unreal from './images/unreal.jpg';
// import Typewriter from './Typewriter';
import { Typewriter, useTypewriter } from 'react-simple-typewriter'
import { app, analytics } from './firebase'
import { logEvent } from "firebase/analytics";
import Type from './Type';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export const CookieContext = React.createContext(null);
function simpleHash(input) {
  let hash = 0;

  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }

  return hash;
}
export const CookieProvider = ({ children }) => {
  const [cookieId, setCookieId] = useState(null);

  useEffect(() => {
    let id = Cookies.get('cookieId');

    if (!id) {
      const now = new Date().toISOString();
      id = simpleHash(now);

      Cookies.set('cookieId', id, { expires: 30 });
    }

    setCookieId(id);
  }, []);

  return (
    <CookieContext.Provider value={cookieId}>
      {children}
    </CookieContext.Provider>
  );
};

logEvent(analytics, 'app start');
export function useDevLog() {
  const log = (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  };

  return {
    log,
  };
}
function timeAgoKST(isoTime) {
  const KST_OFFSET_HOURS = 9;

  // 현재 시간을 가져온다 (KST 기준)
  const now = new Date();
  now.setHours(now.getHours() + KST_OFFSET_HOURS);

  // ISO 형식의 시간을 Date 객체로 변환
  const time = new Date(isoTime);

  // 두 시간의 차이를 계산한다 (밀리초 단위)
  const diffMs = now - time;

  // 밀리초를 시간 단위로 변환
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  // 차이를 일과 시간으로 계산
  const diffDays = Math.floor(diffHours / 24);
  const remainingHours = diffHours % 24;

  // 24시간 이상이면 "x일 x시간 전" 형식으로, 1시간 미만이면 "x분 전" 형식으로, 그렇지 않으면 "x시간 전" 형식으로 반환
  if (diffDays > 0) {
    return `${diffDays}일 ${remainingHours}시간 전`;
  } else if (diffHours > 0) {
    return `${diffHours}시간 전`;
  } else {
    return `${diffMinutes}분 전`;
  }
}


function ClipboardCopy({ copyText }) {
  const [isCopied, setIsCopied] = useState(false);

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(copyText)
      .then(() => {
        // If successful, update the isCopied state value
        window.airbridge.events.send("news_copy");
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (

    <button onClick={() => handleCopyClick(copyText)} class="flex items-center justify-center px-2 py-2 h-8 ml-2 rounded-3xl shadow bg-[#efefef] text-gray-700">
      📋 {isCopied ? '복사됨' : '복사'}
    </button>
  );
}

function getRandomItemFromArray(array) {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const noword = ['다른 뉴스']//['관심없어', '다음뉴스', '궁금하지않아']

function getGreetingByTime() {
  const currentHour = new Date().getHours();
  let greeting;
  const morning = ['좋은 아침입니다.']//, '즐거운 하루 되시길!', '상쾌한 아침이죠?']
  const noon = ['편안한 오후 보내고 계신가요.']
  const evening = ['좋은 저녁입니다.', '오늘 하루 어떻게 보내셨나요.']
  const newsgreeting = ['최신 뉴스를 준비했습니다.', '전해드리고 싶은 소식들을 골라봤습니다.']
  const starting = ['첫번째 소식입니다.', '먼저 알려드릴 소식입니다.', '첫 소식입니다.']//['먼저,', '첫째로,', '우선,']
  if (currentHour < 12) {
    greeting = getRandomItemFromArray(morning) + ' ';
  } else if (currentHour < 18) {
    greeting = getRandomItemFromArray(noon) + ' ';
  } else {
    greeting = getRandomItemFromArray(evening) + ' ';
  }

  return greeting + getRandomItemFromArray(newsgreeting) + ' ' + getRandomItemFromArray(starting);
}

function extractRootDomain(url) {
  let domain;

  // URL에서 프로토콜(http://, https://) 제거
  if (url.indexOf("://") > -1) {
    domain = url.split('/')[2];
  } else {
    domain = url.split('/')[0];
  }

  // 도메인에서 www. 제거
  domain = domain.replace("www.", "");

  // 도메인에서 포트번호 제거
  domain = domain.split(':')[0];

  return domain;
}


// let vh = window.innerHeight * 0.01;
// // Then we set the value in the --vh custom property to the root of the document
// document.documentElement.style.setProperty("--vh", `${vh}px`);

// // We listen to the resize event
// window.addEventListener("resize", () => {
//   // We execute the same script as before
//   let vh = window.innerHeight * 0.01;
//   document.documentElement.style.setProperty("--vh", `${vh}px`);
// });

const Home = () => {
  const [data, setData] = useState([])
  const [end, setEnd] = useState(false)
  const [state, setState] = useState([]);
  const [done, setDone] = useState(false);
  const airbridge = window.airbridge;
  // airbridge.events.send("news_open");
  const cookieId = useContext(CookieContext);



  useEffect(() => {
    if (cookieId) {
      log("cookie!")
      airbridge.setUserId(cookieId);
    }
  }, [cookieId]);

  const { log } = useDevLog()

  // airbridge.fetchResource(function (res) {
  //   log("cookie:", res.browser.clientId) // ex : "2bd08152-0fce-4d5e-8449-f4783b49a2c8"
  //   log(res.attributionData.shortID)
  //   log('cookieId: ', cookieId)
  // })
  log(process.env.NODE_ENV)
  log(process.env.REACT_APP_ANON_KEY)
  useEffect(() => {
    window.scrollTo(0, document.body.scrollHeight);
  }, [data, state, end, done]);

  useEffect(() => {

    async function fetchData() {
      const response = await fetch("https://ksvigvqiwwbgbufzsgpa.supabase.co/functions/v1/news_fetch", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_ANON_KEY}`
        },
        method: "POST",
        body: JSON.stringify({
          best_flag: false
        })
      });
      let json = await response.json()
      //0813 최신순 업데이트      json = shuffleArray(json)

      log("test: ", json)
      let jdata = json[0]
      jdata.fact = getGreetingByTime() + " " + jdata.fact
      setState([[jdata, getRandomItemFromArray(noword), 'pre']])
      setData(json.slice(1))
    }
    airbridge.events.send("news_home_open");
    fetchData()
  }, [])


  const nextItem = (index) => {
    log("data length1: ", data.length)
    if (data.length > 0) {
      setDone(false)
      setState((prevItems) => {
        const newItems = [...prevItems];
        newItems[index][2] = "skip";
        return newItems;
      });

      const nextData = data.slice(1); // data의 첫 번째 요소를 제외한 나머지 요소들
      const newDataItem = [data[0], getRandomItemFromArray(noword), "pre"]; // data의 첫 번째 요소

      setState(prevState => [...prevState, newDataItem]); // 이전 state와 newDataItem을 합쳐 새로운 state를 설정
      setData(nextData); // 다음 data 요소들을 설정
      log(state)
      airbridge.events.send("news_next");
    } else {
      setEnd(true)
      airbridge.events.send("news_next_end");
    }

  };
  const readAndnextItem = (index) => {
    log("data length2: ", data.length)
    if (data.length > 0) {
      setDone(false)
      setState((prevItems) => {
        const newItems = [...prevItems];
        newItems[index][2] = "read";
        return newItems;
      });

      const nextData = data.slice(1); // data의 첫 번째 요소를 제외한 나머지 요소들
      const newDataItem = [data[0], getRandomItemFromArray(noword), "pre"]; // data의 첫 번째 요소

      setState(prevState => [...prevState, newDataItem]); // 이전 state와 newDataItem을 합쳐 새로운 state를 설정
      setData(nextData); // 다음 data 요소들을 설정
      log(state)
      airbridge.events.send("news_read_next");
    } else {
      setEnd(true)
      airbridge.events.send("news_read_next_end");
    }
  };
  const okItem = async (index) => {
    setDone(false)
    setState((prevItems) => {
      const newItems = [...prevItems];
      newItems[index][2] = "ok";


      return newItems;
    });


    log(state)
    const response = await fetch('https://ksvigvqiwwbgbufzsgpa.supabase.co/functions/v1/news_update', {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_ANON_KEY}`
      },
      method: "POST",
      body: JSON.stringify({
        uid: state[index][0].id
      })
    });
    airbridge.events.send("news_read");
  };



  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const navigate = useNavigate();
  const goBest = () => {
    airbridge.events.send("news_go_best");
    navigate('/best');
  };


  return (
    <div className="App">

      <div class="container max-w-[500px] mx-auto"
        style={{ height }}>

        <div>
          <div>
            <div class="w-full">


              <div class="fixed w-full max-w-[498px] mx-auto z-10 bg-white shadow-md">
                <div class="max-w-[498px] relative flex items-center p-3 ">
                  <img class="object-cover w-10 h-10 rounded-full" src={unreal} alt="unreal" />
                  <span class="block ml-2 font-bold text-gray-600">AI가 대신 읽어주는 뉴스</span>
                  <span class="absolute w-3 h-3 bg-green-600 rounded-full left-10 top-3"></span>
                  <button onClick={goBest} class="ml-auto bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                    인기뉴스
                  </button>
                </div>
              </div>



              <div class="relative w-full p-6 pt-20 overflow-y-auto "
              // style={{
              // minHeight: '100vh',
              //   minHeight: 'calc(var(--vh, 1vh) * 100)',
              // }}>
              // style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
              >

                <ul class="space-y-4">
                  {/* <li class="flex justify-start">
                    <div class="relative px-4 py-2 text-gray-700 bg-[#efefef] rounded shadow max-w-sm">
                      <span class="block text-left">

                        <Typewriter words={[greeting]}
                          typeSpeed={30}
                        />
                       
                      </span>

                    </div>

                  </li> */}

                  {state.length === 0 ? (
                    // 데이터가 없을 때 로딩 스피너를 보여줍니다.
                    <div class="text-center">
                      <div role="status">
                        <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    // {
                    state.map((item, index) => (<>
                      <li class="flex justify-start">
                        <div class="relative px-4 py-2 text-gray-700 bg-[#efefef] rounded shadow max-w-sm">
                          <span class="block text-left">
                            {/* <Typewriter words={[item[0].fact]}
                            typeSpeed={15}
                            onType={() => handleDone(item[0].fact)}
                          /> */}

                            <Type
                              text={item[0].fact}
                              setDone={setDone} />
                          </span>

                        </div>

                      </li>
                      {item[2] === 'pre' && done && (
                        <li>
                          <div class="flex ">
                            <button onClick={() => okItem(index)} class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-blue-500 hover:bg-blue-600 text-white ">
                              <span class="max-w-[100px] overflow-hidden truncate whitespace-nowrap">{item[0].emojis}</span>
                            </button>
                            <button onClick={() => nextItem(index)} class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow ml-2 border border-blue-500  text-blue-600">
                              {item[1]}
                            </button>
                            <span class="flex items-center justify-center px-2 py-2 h-8 ml-2 text-gray-400">
                              {timeAgoKST(item[0].created_at)}
                            </span>
                          </div>
                        </li>
                      )}
                      {(item[2] === 'ok') && (
                        <><li class="flex justify-end">
                          <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-white text-gray-700 cursor-default ">
                            <span class="max-w-[200px] overflow-hidden truncate whitespace-nowrap">{item[0].emojis}</span>
                          </button>
                        </li><li class="flex justify-start mt-4">
                            <div class="relative px-4 py-2 text-gray-700 bg-[#efefef] rounded shadow max-w-sm">
                              <span class="block text-left">
                                <Type
                                  text={item[0].summary.join(' ')}
                                  setDone={setDone} />

                              </span>
                            </div>
                          </li>



                        </>
                      )}


                      {item[2] === 'ok' && done && (
                        <li>
                          <div class="flex ">
                            <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-[#efefef] text-gray-700 ">
                              <a class="max-w-[100px] overflow-hidden truncate whitespace-nowrap" href={item[0].url} onClick={() => airbridge.events.send("news_link")} target="_blank" rel="noopener noreferrer">🔗 {extractRootDomain(item[0].url)}</a>
                            </button>
                            {/* <ClipboardCopy copyText={item[0].summary.join(' ') + "\n" + item[0].url} /> */}
                            <button onClick={() => readAndnextItem(index)} class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow ml-2 border border-blue-500  text-blue-600">
                              다른 뉴스
                            </button>
                            <span class="flex items-center justify-center px-2 py-2 h-8 ml-2 text-gray-400">
                              {timeAgoKST(item[0].created_at)}
                            </span>
                          </div>
                        </li>

                      )}


                      {item[2] === 'read' && (
                        <><li class="flex justify-end">
                          <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-white text-gray-700 cursor-default ">
                            <span class="max-w-[200px] overflow-hidden truncate whitespace-nowrap"> {item[0].emojis}</span>
                          </button>
                        </li><li class="flex justify-start mt-4">
                            <div class="relative px-4 py-2 text-gray-700 bg-[#efefef] rounded shadow max-w-sm">
                              <span class="block text-left">{item[0].summary.join(' ')}
                                {/* <Type
                                text={item[0].summary.join(' ')}
                                setDone={setDone} /> */}
                              </span>
                            </div>
                          </li>


                        </>
                      )}

                      {item[2] === 'read' && done && (
                        <>
                          <li>
                            <div class="flex ">
                              <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-[#efefef] text-gray-700">
                                <a class="max-w-[100px] overflow-hidden truncate whitespace-nowrap" href={item[0].url} onClick={() => airbridge.events.send("news_link")} target="_blank" rel="noopener noreferrer">🔗 {extractRootDomain(item[0].url)}</a>
                              </button>
                              {/* <ClipboardCopy copyText={item[0].summary.join(' ') + "\n" + item[0].url} /> */}
                              <span class="flex items-center justify-center px-2 py-2 h-8 ml-2 text-gray-400">
                                {timeAgoKST(item[0].created_at)}
                              </span>
                            </div>
                          </li>
                          <li class="flex justify-end">
                            <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-white text-gray-700 cursor-default ">
                              다른 뉴스
                            </button></li>
                        </>
                      )}

                      {item[2] === 'skip' && (
                        <li class="flex justify-end">
                          <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-white text-gray-700 cursor-default ">
                            {item[1]}
                          </button>
                        </li>
                      )}



                    </>
                    ))
                    // }
                  )}
                  {end === true && (
                    <li class="flex justify-start">
                      <div class="relative px-4 py-2 text-gray-700 bg-[#efefef] rounded shadow max-w-sm">
                        <span class="block text-left">

                          <Type
                            text={"제가 준비한 소식은 여기까지입니다. 다시 방문하실때 볼 수 있는 뉴스를 준비해놓을게요."}
                            setDone={setDone} />
                        </span>

                      </div>

                    </li>
                  )}

                </ul>

              </div>


            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

const Best = () => {
  const navigate = useNavigate();
  const [height, setHeight] = useState(window.innerHeight);
  const [state, setState] = useState([]);
  const { log } = useDevLog()
  const airbridge = window.airbridge;
  let fetch_url;
  if (process.env.NODE_ENV === 'development') {
    fetch_url = "http://localhost:54321/functions/v1/news_fetch"
  } else {
    fetch_url = "https://ksvigvqiwwbgbufzsgpa.supabase.co/functions/v1/news_fetch"
  }

  useEffect(() => {

    async function fetchData() {
      const response = await fetch(fetch_url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_ANON_KEY}`
        },
        method: "POST",
        body: JSON.stringify({
          best_flag: true
        })
      });
      let json = await response.json()
      setState(json)
    }
    airbridge.events.send("news_best_open");
    fetchData()
  }, [])


  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const goBack = () => {
    airbridge.events.send("news_go_back");
    navigate('/');
  };
  const handleSubscribe = () => {
    airbridge.events.send("news_subscribe_btn");
    const email = document.getElementById('email').value;
    const url = `https://page.stibee.com/subscriptions/267088?email=${email}`;
    window.open(url, '_blank');
  };
  //<button onClick={goBack}>Go Back</button>

  return (
    <div className="App">

      <div class="container max-w-[500px] mx-auto"
        style={{ height }}>

        <div>
          <div>
            <div class="w-full">


              <div class="fixed w-full max-w-[498px] mx-auto z-10 bg-white shadow-md">

                <div class="max-w-[498px] relative flex items-center p-3 ">
                  <button
                    onClick={goBack}
                    className="flex items-center px-3 py-2 font-bold text-gray-600 "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 mr-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                    뒤로가기
                  </button>


                </div>
              </div>



              <div class="relative w-full p-6 pt-20 overflow-y-auto "

              >
                <h1 class="text-xl text-left">인기뉴스</h1>
                <p class="text-base text-left mt-4">24시간 전 인기뉴스 5개를 소개해드립니다. 이메일로 구독하시면 매주 월요일 주간 인기 뉴스도 받아보실 수 있습니다. (<a href='https://page.stibee.com/archives/267088' class="text-blue-500" onClick={() => airbridge.events.send("news_past_list")} target="_blank" rel="noopener noreferrer">지난 뉴스레터 모음</a>) </p>
                <div class="flex items-stretch mt-4">
                  <input id="email" class="bg-gray-100 rounded-lg rounded-r-none text-base leading-none text-gray-800  px-5 py-2 w-4/5 border border-transparent focus:outline-none focus:border-gray-500" type="email" placeholder="이메일 주소" />
                  <button onClick={handleSubscribe} class="w-48 rounded-l-none bg-blue-500 hover:bg-blue-600 text-white font-bold rounded text-base  leading-none  px-5 py-2 uppercase focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700">인기뉴스구독</button>
                </div>
                <ul class="mt-10">


                  {state.length === 0 ? (
                    // 데이터가 없을 때 로딩 스피너를 보여줍니다.
                    <div class="text-center mt-10">
                      <div role="status">
                        <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    // {
                    state.map((item, index) => (<>
                      <h4 class="text-lg font-bold text-left">{item.fact}</h4>
                      <p class="text-gray-500 text-left mt-2">
                        {item.summary.join(' ')}
                      </p>
                      <div class="flex mt-2 mb-10">
                        <button class="flex items-center justify-center px-2 py-2 h-8 rounded-3xl shadow bg-[#efefef] text-gray-700">
                          <a class="max-w-[100px] overflow-hidden truncate whitespace-nowrap" href={item.url} onClick={() => airbridge.events.send("news_link_best")} target="_blank" rel="noopener noreferrer">🔗 {extractRootDomain(item.url)}</a>
                        </button>
                        <ClipboardCopy copyText={item.summary.join(' ') + "\n" + item.url} />
                        <span class="flex items-center justify-center px-2 py-2 h-8 ml-2 text-gray-400">
                          {timeAgoKST(item.created_at)}
                        </span>
                      </div>












                    </>
                    ))
                    // }
                  )}


                </ul>

              </div>


            </div>
          </div>
        </div>
      </div>

    </div>


  );
};


const App = () => (
  <Router>
    <CookieProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/best" element={<Best />} />
      </Routes>
    </CookieProvider>
  </Router>
);

export default App;
